
define('template!runAtCreateEditLayoutTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="detailed-info-form-container">\n  <div class="saving-label"></div>\n  <div class="error-label">' +
((__t = ( _.i18n('common.serverError') )) == null ? '' : __t) +
'\n      <div class="error-msg">  </div>\n  </div>\n  <div class="form-horizontal">\n    <div class="form-inputs-container">\n      <div class="form-group checkbox-group" data-field-name="override">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n("runat.override") )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9 checkbox checkbox-primary">\n          <label>\n            <input type="checkbox" id="override" class="js-keep-logged-in">\n          </label>\n        </div>\n      </div>\n      <div class="form-group" data-field-name="baseline">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('runat.baseline') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <input type="number" class="form-control floating-label js-info-input" data-field-name="baseline"\n                 placeholder="' +
((__t = ( _.i18n('runat.baseline') )) == null ? '' : __t) +
'" value="' +
((__t = ( baseline )) == null ? '' : __t) +
'">\n        </div>\n      </div>\n      <div class="form-group" data-field-name="threshold">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('runat.threshold') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <input type="number" class="form-control floating-label js-info-input" data-field-name="threshold"\n                 placeholder="' +
((__t = ( _.i18n('runat.threshold') )) == null ? '' : __t) +
'" value="' +
((__t = ( threshold )) == null ? '' : __t) +
'">\n        </div>\n      </div>\n      <div class="row">\n        <div class="pull-right p-r-15">\n          <button class="btn btn-default btn-flat cancel-b js-cancel-popup">' +
((__t = ( _.i18n('common.cancel') )) == null ? '' : __t) +
'</button>\n          <button disabled class="btn btn-primary disabled-grey js-confirm">' +
((__t = ( _.i18n('common.confirm') )) == null ? '' : __t) +
'</button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>';

}
return __p
};});

